import React from 'react';
import showConfirmModal from './showConfirmModal';

function showApplyWarning() {
  return showConfirmModal({
    title: '操作确认',
    content: (
      <>
        <div className="mb-5 text-xl">是否清空相应内容？</div>
        <div className="text-center">
          因当前场景为空，把空内容应用到其它场景后，会对应进行清空，请谨慎操作！
        </div>
      </>
    ),
  });
}

export default showApplyWarning;
